"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_tags_1 = require("common-tags");
var __1 = require("../../../");
var algo_1 = require("../../../algo");
var component_1 = require("../../../component");
var element_1 = require("../../../element");
var base_1 = require("./base");
var LabelRenderer = /** @class */ (function (_super) {
    __extends(LabelRenderer, _super);
    function LabelRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultScaleDataKey = "label";
        return _this;
    }
    LabelRenderer.prototype.renderSection = function (section) {
        var _this = this;
        _super.prototype.renderSection.call(this, section);
        var circos = section.parent.circos;
        var inversed = this._getOption("inversed", false);
        var bp1 = this._getOption("bp1", 7);
        var bp2 = this._getOption("bp2", 14);
        var bp3 = this._getOption("bp3", 21);
        this._group = section.appendGroupT(component_1.Component).options({
            _data: function (d, i, g) {
                var innerR = _this._r(true, section, d._key);
                var outerR = _this._r(false, section, d._key);
                var data = _this.transformData(d).data;
                var xScale = section.parent.circos.xScaleForChr(d._key);
                // group label first
                var degPerPx = 180 / (innerR * Math.PI);
                var gapAsDeg = 10 * degPerPx;
                var offsetAsDeg = 2 * degPerPx;
                var _a = xScale.range(), dmin = _a[0], dmax = _a[1];
                var offsetR = function (o) { return inversed ? outerR - o : innerR + o; };
                return algo_1.labelGroup(data).minGap(gapAsDeg).maxSize([dmin, dmax]).displayX(function (x) { return xScale(x.pos); }).run()
                    .map(function (x) { return (__assign(__assign({}, x), { lineStart: __1.tool.polar2cart(x._displayX, offsetR(0)), lineMid1: __1.tool.polar2cart(x._displayX, offsetR(bp1)), lineMid2: __1.tool.polar2cart(x._adjustedX, offsetR(bp2)), lineEnd: __1.tool.polar2cart(x._adjustedX, offsetR(bp3)), textPos: __1.tool.polar2cart(x._adjustedX + (x._adjustedX > 180 ? 1 : -1) * offsetAsDeg, offsetR(21)) })); });
            },
        });
        this._lines = this._group.appendT(element_1.Path).options({
            d: function (d) {
                return common_tags_1.oneLineTrim(templateObject_1 || (templateObject_1 = __makeTemplateObject(["M", ",", "\n                        L", ",", "\n                        L", ",", "\n                        L", ",", ""], ["M", ",", "\n                        L", ",", "\n                        L", ",", "\n                        L", ",", ""])), d.lineStart[0], d.lineStart[1], d.lineMid1[0], d.lineMid1[1], d.lineMid2[0], d.lineMid2[1], d.lineEnd[0], d.lineEnd[1]);
            },
            fill: "none",
            stroke: "#ccc",
        });
        this._labels = this._group.appendT(element_1.Text).options({
            _x: function (d) { return d.textPos[0]; },
            _y: function (d) { return d.textPos[1]; },
            _text: function (d) { return d.text; },
            _rotation: function (d) { return circos.labelRotation(d._adjustedX, d.lineEnd[0], d.lineEnd[1]); },
            _anchor: function (d) { return circos.labelAnchor(d._adjustedX, !inversed); },
            fill: "#ccc",
            "font-size": 10,
        });
        this.assignGOptions({ dot: "_points", line: "_lines" });
    };
    return LabelRenderer;
}(base_1.Renderer));
exports.LabelRenderer = LabelRenderer;
var templateObject_1;
//# sourceMappingURL=label.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/label.js
// module id = 1182
// module chunks = 0 1